import { render } from "./PublicationUserManagement.vue.js?vue&type=template&id=631a72c1!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUserManagement.vue?vue&type=template&id=631a72c1"
import script from "./PublicationUserManagement.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUserManagement.vue?vue&type=script&lang=js"
export * from "./PublicationUserManagement.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUserManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationUserManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "631a72c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('631a72c1', __exports__)) {
    api.reload('631a72c1', __exports__)
  }
  
  module.hot.accept("./PublicationUserManagement.vue.js?vue&type=template&id=631a72c1!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUserManagement.vue?vue&type=template&id=631a72c1", () => {
    api.rerender('631a72c1', render)
  })

}


export default __exports__